import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createTextVNode as _$ct,
} from 'intact';
import {Button, Think, Icon} from 'kpc';

var _$tmp0 = {
    'className': 'ion-lightbulb',
    'style': 'color: #1677ff;'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', (
        _$cc(Think, {
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['icon'] = function($super) {
                            return (
                                _$cc(Icon, _$tmp0)
                            );
                        }),
                        (__$blocks['icon'] = function($super, data) {
                            var block = $blocks['icon'];
                            var callBlock = function() {
                                return _$blocks['icon'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    (
                        (_$blocks['title'] = function($super) {
                            return (
                                _$ce(2, 'span', '自定义思考标题', 16)
                            );
                        }),
                        (__$blocks['title'] = function($super, data) {
                            var block = $blocks['title'];
                            var callBlock = function() {
                                return _$blocks['title'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    (
                        (_$blocks['extra'] = function($super) {
                            return (
                                _$ce(2, 'span', [
                                    _$ct('耗时 '),
                                    this.get('duration'),
                                    _$ct('s')
                                ], 0, 'think-demo-slots-extra')
                            );
                        }),
                        (__$blocks['extra'] = function($super, data) {
                            var block = $blocks['extra'];
                            var callBlock = function() {
                                return _$blocks['extra'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    (
                        (_$blocks['content'] = function($super) {
                            return (
                                _$ce(2, 'div', [
                                    _$ce(2, 'div', [
                                        _$ce(2, 'strong', '问题分析：', 16),
                                        _$ce(2, 'p', '用户询问关于 AI 模型选择的问题，需要从性能、成本、易用性等维度综合评估。', 16)
                                    ], 4, 'think-demo-slots-item'),
                                    _$ce(2, 'div', [
                                        _$ce(2, 'strong', '技术考量：', 16),
                                        _$ce(2, 'p', '模型参数量、推理速度、显存占用是关键指标，需要根据实际使用场景权衡。', 16)
                                    ], 4, 'think-demo-slots-item'),
                                    _$ce(2, 'div', [
                                        _$ce(2, 'strong', '建议方案：', 16),
                                        _$ce(2, 'p', '建议从开源模型开始尝试，确认效果后再考虑商业化方案。', 16)
                                    ], 4, 'think-demo-slots-item')
                                ], 4, 'think-demo-slots-content')
                            );
                        }),
                        (__$blocks['content'] = function($super, data) {
                            var block = $blocks['content'];
                            var callBlock = function() {
                                return _$blocks['content'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        })
    ), 2, 'think-demo-slots');
};